import * as React from "react";
import { Loader2 } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface DropdownItemProps {
  label: string;
  value: string;
}

interface DropdownProps {
  items: DropdownItemProps[];
  onSelect: (value: string | null) => void;
  buttonLabel: string;
  isLoading?: boolean;
  variant?: "outline" | "solid";
  showSelectedValue?: boolean;
  selectedValue?: string | null;
  includeClearOption?: boolean;
  clearOptionLabel?: string;
}

const ALL_VALUE = "__all__";

const Dropdown: React.FC<DropdownProps> = ({
  items,
  onSelect,
  buttonLabel,
  isLoading = false,
  variant = "solid",
  selectedValue,
  includeClearOption = false,
  clearOptionLabel = "Effacer la sélection",
}) => {
  const handleValueChange = (value: string) => {
    if (value === ALL_VALUE) {
      onSelect(null);
    } else {
      onSelect(value);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground">
        <Loader2 className="h-4 w-4 animate-spin" />
        Chargement...
      </div>
    );
  }

  const selectValue = selectedValue ?? (includeClearOption ? ALL_VALUE : undefined);

  return (
    <Select
      value={selectValue}
      onValueChange={handleValueChange}
    >
      <SelectTrigger
        className={cn(
          "w-auto min-w-[120px] h-9",
          variant === "solid" && "bg-primary text-white border-primary",
          variant === "outline" && "bg-white text-card-foreground border-border"
        )}
      >
        <SelectValue placeholder={buttonLabel} />
      </SelectTrigger>
      <SelectContent>
        {includeClearOption && (
          <SelectItem value={ALL_VALUE}>{clearOptionLabel}</SelectItem>
        )}
        {items.map((item) => (
          <SelectItem key={item.value} value={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default Dropdown;
